const $ = window.jQuery;
import debounce from "../utils/debounce";

export default {

    placeholder_image_data: '',

    init() {

        // Bail if we aren't on the right page.
        if (!$('body.page-template-page-plugin-review').length) {
            return;
        }

        // Update the preview as the user types.
        $('.af-field-type-calculated').closest('form').on('keyup', debounce(300, () => {
            acf.doAction('af/field/calculated/update_value/name=review_preview');
        }));

        // Load the preview in our custom HTML element — this is outside of the form markup.
        acf.addAction('af/field/calculated/value_updated/name=review_preview', (value, field, form) => {
            if (this.placeholder_image_data) {
                value = $(value).find('.testimonial__image > img').attr('src', this.placeholder_image_data).end();
            }

            $('.ReviewForm__preview').html(value);
        });

        // When image field changes, update the image data for use in the preview.
        const $image_upload = $("#acf-field_5da1110c5732d");
        $image_upload.change(() => {
            const element = $image_upload[0];

            if (element.files && element.files[0]) {
                const reader = new FileReader();

                reader.onload = (e) => {
                    this.placeholder_image_data = e.target.result;
                };

                reader.readAsDataURL(element.files[0]);
            }

        });

    }

}